import { Component, ViewEncapsulation, Input, Output, EventEmitter} from '@angular/core';

@Component({
	selector: 'corporate-awards-box',
	templateUrl: './corporate-awards-box.component.html',
	styleUrls: ['./corporate-awards-box.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class CorporateAwardsBoxComponent {

	@Input() theme: string;
	@Output() onModalVisibleChange = new EventEmitter<any>();

	constructor() {}

	showAwardeeModal(){
		this.onModalVisibleChange.emit();
	}

	ngOnInit() {}
}